var map = {
	"./sicbo2_en.png": "FDIN",
	"./sicbo2_esp.png": "9ev2",
	"./sicbo2_th.png": "Xyo/"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3UN7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/sicbo2_.*\.png$
// module id = 3UN7
// module chunks = 1